import React from "react";
import { Button, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import StateTemplate from "./StateTemplate";

export type SyncDetailsErrorStateProps = {
  entityName: string | undefined;
  errorMessage: string;
  onRetry: () => void;
};

const SyncDetailsErrorState = ({
  entityName,
  errorMessage,
  onRetry,
}: SyncDetailsErrorStateProps) => {
  const subTitle = (
    <>
      We couldn&apos;t load the GL sync details{entityName ? ` for ${entityName}` : ""}, so the
      sync settings can&apos;t be shown. Please try again, or contact support if the problem
      persists.
      <br />
      <Text asSpan variant="secondary-sm" data-testid="sync-details-error-message">
        {errorMessage}
      </Text>
    </>
  );
  return (
    <StateTemplate
      title="Unable to load sync settings"
      subTitle={subTitle}
      icon={<Icon type="exclamation-circle" color={Colors.Danger600} size="xx-large" />}
    >
      <Button onClick={onRetry}>Try again</Button>
    </StateTemplate>
  );
};

export default SyncDetailsErrorState;
